/**
 * Created by xuetao.liu on 2018/10/9.
 * @Description mounted common plugin or lib
 */
import $http from '@/utils/request'
import $api from './api'

export default {
  install(Vue,options){
    Vue.prototype.$http = $http;
    Vue.prototype.$api = $api;
  }
}


// WEBPACK FOOTER //
// ./src/libs/inject.js